import {IntlKeyValuePair, IntlNamespaces} from "./types";

export const INTL_GENERIC_ERROR: IntlKeyValuePair = {
    key: "genericError",
    defaultValue: "An error occurred, please try again",
    intlValue: "An error occurred, please try again",
    namespace: IntlNamespaces.ERROR_MESSAGE,
};
